<div class="menu-container" [formGroup]="form">

    <div class="menu-header">
        <div class="back-arrow">
            <button class="dotted-arrow" mat-icon-button (click)="closeCreateQuote()">←</button>
        </div>
        <h3 i18n="@@create-new-quote_create" class="headline">Create new quote</h3>
    </div>

    <div class="name-input">
        <input type="text" placeholder="Name your quote..." i18n-placeholder="@@create-new-quote_placeholder" formControlName="name" [autofocus]="true">
        <span *ngIf="form.controls.name.errors && form.touched">Length needs to be between 4 and 64</span>
    </div>

    <div class="footer create-quote-footer">
        <button class="btn-primary main-btn" (click)="closeCreateQuote()" i18n="@@create-new-quote_cancel-button">Cancel</button>
        <button class="btn-primary main-btn" (click)="onCreateQuote()" i18n="@@create-new-quote_create-button">Create</button>
    </div>
</div>
